<template>
  <div class="sample-list-container">
    <div class="sample__wrapper" v-if="samples.length > 0">
      <router-link
        class="sample__item"
        v-for="sample in samples"
        :key="sample.id"
        tag="div"
        :to="`/sample/${sample.id}`"
        :class="{
          'scroll-up-to upObj': theme !== 'manage',
          mangeHover: theme === 'manage'
        }"
      >
        <div class="item__manage" v-if="theme === 'manage'">
          <div class="manage__item" @click.stop="onEdit(sample.id)">
            <i class="icon icon-manage-edit"></i>
          </div>
          <div class="manage__item" @click.stop="onDelete(sample.id)">
            <i class="icon icon-manage-delete"></i>
          </div>
          <div class="manage__item" @click.stop="routergo(sample.id)">
            <i class="icon icon-manage-preview"></i>
          </div>
        </div>
        <div class="item__cover">
          <el-image
            class="img"
            :src="sample.title_picture_url | parseImage"
            alt=""
            fit="cover"
          ></el-image>
          <div class="cover__text">{{ sample.mold_name }}·{{ sample.mold_en_name }}</div>
        </div>
        <div class="item__info">
          <div class="info__base">
            <p class="base__name">{{ sample.name }}</p>
            <p class="base__price">
              {{ userInfo && !userInfo.isMerchant ? "￥" : "" }}{{ sample.price }}
            </p>
          </div>
          <div class="info__sell">
            <p class="sell__text">已售：{{ sample.order_num }}</p>
            <p class="sell__views" style="display:none;">
              <i class="views__icon icon icon-view"></i>{{ sample.order_num }}
            </p>
          </div>
        </div>
      </router-link>
    </div>
    <Empty hint="没有找到相关信息" v-else></Empty>
    <Pagination
      :config="isShowPagination"
      class="component-pagination"
      v-if="isShowPagination && samples.length > 0"
    ></Pagination>
  </div>
</template>

<script>
import Pagination from '@/components/pagination.vue';
import Empty from '@/pages/common/empty.vue';
import { mapState } from 'vuex';

export default {
  components: {
    Pagination,
    Empty,
  },
  props: {
    samples: {
      type: Array,
      default: () => [],
    },
    isShowPagination: {
      type: Object,
      default: null,
    },
    theme: {
      type: String,
      default: null,
    },
  },
  computed: mapState('user', {
    userInfo: (state) => state.info,
  }),
  methods: {
    routergo(id) {
      this.$router.push({
        path: `/sample/${id}`,
      });
    },
    onEdit(id) {
      this.$router.push({
        path: `/my/sample/${id}`,
      });
    },
    onDelete(id) {
      this.$emit('onDelete', id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_mixin";
.component-pagination {
  margin-top: px2vw(98 - 29);
}
</style>
